import { FC } from 'react';

import { DismissBanner } from '../DismissBanner';
import { Body2InheritStyle, NoticeBannerBullet, SpacedWarningBanner } from '../Styled';
import { ModelQuality, PredictiveGoalModelDetails } from '../../types';

export type NoticeBannerProps = {
  modelDetails: PredictiveGoalModelDetails;
};
export const NoticeBanner: FC<React.PropsWithChildren<NoticeBannerProps>> = ({ modelDetails }) => {
  if (modelDetails?.model_quality === ModelQuality.Weak) {
    if (
      [ModelQuality.Satisfactory, ModelQuality.Strong].includes(
        modelDetails?.previous_model_quality as any,
      )
    ) {
      return (
        <DismissBanner BannerComponent={SpacedWarningBanner} title="Reducted predictive strength">
          <Body2InheritStyle>
            This goal has a reduced predictive strength compared to the previous version. Please try
            the following to improve it:
          </Body2InheritStyle>
          <ul>
            <NoticeBannerBullet>
              <Body2InheritStyle>Change your predictive goal criteria</Body2InheritStyle>
            </NoticeBannerBullet>
            <NoticeBannerBullet>
              <Body2InheritStyle>
                Check if associated events/properties have sufficient data
              </Body2InheritStyle>
            </NoticeBannerBullet>
            <NoticeBannerBullet>
              <Body2InheritStyle>
                Wait until the next refresh cycle and check again
              </Body2InheritStyle>
            </NoticeBannerBullet>
          </ul>
        </DismissBanner>
      );
    }

    return (
      <DismissBanner BannerComponent={SpacedWarningBanner} title="Weak predictive strength">
        <div>
          <Body2InheritStyle>
            This goal has a weak predictive strength. We recommend you edit and try the following to
            improve it:
          </Body2InheritStyle>
          <ul>
            <NoticeBannerBullet>
              <Body2InheritStyle>Change your predictive goal criteria</Body2InheritStyle>
            </NoticeBannerBullet>
            <NoticeBannerBullet>
              <Body2InheritStyle>
                Check if associated events/properties have sufficient data
              </Body2InheritStyle>
            </NoticeBannerBullet>
          </ul>
        </div>
      </DismissBanner>
    );
  }
  return null;
};
